/**
 * Stored on the distributor to mean "no products at all". The other two stored
 * values are an empty string ("all products") and a catalog id.
 */
export const NO_CATALOG = 'NO_CATALOG';

/**
 * Stands in for the empty stored value inside the field. HeroUI drops an empty
 * key, which is what left the box blank for "Show all products".
 */
export const SHOW_ALL_PRODUCTS_KEY = '__show_all_products__';

export const toFieldKey = (storedValue: string): string =>
  storedValue === '' ? SHOW_ALL_PRODUCTS_KEY : storedValue;

export const fromFieldKey = (key: string): string =>
  key === SHOW_ALL_PRODUCTS_KEY ? '' : key;
